<template>
  <div>
    <div class="modal-overlay" @click="closeConsolidatedModal" v-if="open"></div>
    <div class="rates-modal-container" :class="[open ? 'open' : 'closed']">
      <h1>Consolidated Orders</h1>
      <div class="date-picker-container">
        <label class="date-picker-label">
          Start Date
          <date-picker v-model="startDate" :local="localSettings"></date-picker>
        </label>
        <label class="date-picker-label">
          End Date
          <date-picker
            :local="localSettings"
            class="date-picker"
            v-model="endDate"
            placeholder="End Date"
          ></date-picker>
        </label>
        <button @click="searchConsolidated" class="btn btn-primary">
          Search
          <font-awesome-icon v-if="loading" icon="circle-notch" spin class="loading-spinner" />
        </button>
      </div>
      <div v-if="orders && Object.keys(orders).length === 0">
        <p>No consolidated orders found</p>
      </div>
      <table v-else>
        <tr class="order_break" v-for="order in orders" :key="order.id">
          <table>
            <tr>
              <th>Order Number</th>
              <th>Ship To</th>
              <th>Weight</th>
              <th>&nbsp;</th>
            </tr>
            <tr v-for="order_item in order.orders" :key="order_item.order_number">
              <td>{{order_item.order_number}}</td>
              <td>{{order_item.ship_to}}</td>
              <td>{{order_item.weight}}</td>
              <td></td>
            </tr>
          </table>
          <td>
            <button @click="selectOrders(order.orders)" class="btn btn-primary">Select Orders</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      startDate: new Date(),
      endDate: new Date(),
      localSettings: {
        dow: 1,
        hourTip: "Select Hour",
        minuteTip: "Select Minute",
        secondTip: "Select Second",
        yearSuffix: "",
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ),
        weeks: "",
        cancelTip: "Cancel",
        submitTip: "Submit"
      }
    };
  },
  props: ["orders", "open", "loading"],
  methods: {
    closeConsolidatedModal() {
      this.$emit("closeConsolidatedModal");
    },
    selectOrders(orders) {
      this.$emit("ordersSelected", orders);
    },
    searchConsolidated() {
      this.$emit("searchConsolidated", this.startDate, this.endDate);
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

td,
th {
  padding: 0.7rem;
}

tr {
  border-bottom: 1px solid black;
}

tr:last-child {
  border-bottom: none;
}

.date-picker-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid black;
  padding: 1rem 0.5rem;
}

.date-picker-container .btn-primary {
  margin-top: 1rem;
  width: 100px;
  margin-left: 0.5rem;
}

.order_break {
  border-bottom: 2px solid black;
}

.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}
.date-picker {
  display: inline-block;
}

.date-picker-label {
  display: inline-block;
  text-align: left;
  margin: 0;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.rates-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  height: 500px;
  width: 500px;
  text-align: center;
  background: white;
  margin-left: -250px;
  border-radius: 20px;
  margin-top: -250px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

h1 {
  padding: 1rem;
  margin: 0;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
